import React from 'react';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import TablseSection from './TablseSection'
const PlayerList = () => {
    return (
        <div className="App2">
            <h1>Coming Soon..... </h1>
        </div>
    )
};
export default PlayerList;